import React from 'react';
import styled from 'styled-components';
import { FaBuilding, FaAnchor, FaTv, FaCode, FaHeart, FaSatelliteDish } from 'react-icons/fa';

const icons = {
  building: FaBuilding,
  anchor: FaAnchor,
  tv: FaTv,
  code: FaCode,
  heart: FaHeart,
  satellite: FaSatelliteDish,
};

const Cover = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.9rem;
  text-align: center;
  padding: 1.5rem;
  color: #fff;
  background:
    radial-gradient(120% 120% at 0% 0%, ${(p) => p.$from} 0%, transparent 55%),
    radial-gradient(120% 120% at 100% 100%, ${(p) => p.$to} 0%, transparent 55%),
    #0b1020;
  overflow: hidden;

  /* subtle dotted texture */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: radial-gradient(rgba(255, 255, 255, 0.14) 1px, transparent 1px);
    background-size: 18px 18px;
    mask-image: radial-gradient(circle at 50% 45%, black, transparent 75%);
    -webkit-mask-image: radial-gradient(circle at 50% 45%, black, transparent 75%);
    opacity: 0.5;
  }

  .glyph {
    display: grid;
    place-items: center;
    width: 64px;
    height: 64px;
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.25);
    backdrop-filter: blur(4px);
    font-size: 1.7rem;
    z-index: 1;
  }
  .org {
    z-index: 1;
    font-family: var(--font-heading);
    font-weight: 700;
    font-size: 1.05rem;
    letter-spacing: -0.01em;
    text-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);
  }
`;

const ProjectCover = ({ cover, org }) => {
  const Icon = icons[cover?.icon] || FaCode;
  return (
    <Cover $from={cover?.from || '#6366f1'} $to={cover?.to || '#ec4899'}>
      <span className="glyph"><Icon /></span>
      <span className="org">{org}</span>
    </Cover>
  );
};

export default ProjectCover;
